document.addEventListener('DOMContentLoaded', function() {
  function setGridColumns() {
    var lists = document.querySelectorAll('.section-product-list_list[data-col-pc]');
    var isPC = window.matchMedia('(min-width: 980px)').matches;

    lists.forEach(function(ul) {
      var colPc = ul.dataset.colPc || 4;
      var colSp = ul.dataset.colSp || 2;

      if (isPC) {
        // PC版は設定値の列数を使用
        ul.style.gridTemplateColumns = 'repeat(' + colPc + ', 1fr)';
      } else {
        // SP版は設定値の列数を使用
        ul.style.gridTemplateColumns = 'repeat(' + colSp + ', 1fr)';
      }
    });
  }

  setGridColumns();
  window.addEventListener('resize', setGridColumns);
});